// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"298":"a20e9cab","408":"3c7ead37"}[chunkId] + ".css";
};